import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

import VueAxios from 'vue-axios'
Vue.config.devtools = true;
import vuetify from './plugins/vuetify'
import '@babel/polyfill'
import store from './store/index'
import trim from './directives/trim'
import mayusculas from './directives/mayusculas'

Vue.use(VueAxios,axios);

axios.defaults.baseURL=process.env.VUE_APP_API_URL

Vue.component('base-section', () => import('./components/UI/BaseSection.vue'));

Vue.directive('trim', trim);
Vue.directive('mayusculas', mayusculas);

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
